<template lang="pug">
  .delivery-order-container
    .list-items.form
      .item-delivery.capitalize {{ delivery.delivery }} ({{ delivery.type }})
      .item-delivery.capitalize {{ text.states[delivery.status] }}
      .item-delivery {{ delivery.conveyor || '-' }}
      .item-delivery {{ delivery.tracking || '-' }}
      .item-delivery {{ dateTime(delivery.createdAt) }}
      shExpandButton.line(@click.native="show = !show" :expand="show")

    transition(name="slide-fade")
      div(v-if="show")
        .input-container
          input.input(v-model="delivery.nameRecipient" autocomplete="ño" disabled required)
          label.label(:class="{ show: delivery.nameRecipient }") Name Recipient

        shInputList(:dataForm="delivery" :dataOriginal="delivery" title="Phone Recipient" property="phonesRecipient" pattern="[0-9]{10}" :fillData="true" :required="1")

        .input-container
          textarea.input(v-model="delivery.addressRecipient" autocomplete="ño" rows="3" disabled required)
          label.label(:class="{ show: delivery.addressRecipient }") Address

        h3(v-if="delivery.observations && delivery.observations.length") Observations
        .observations-container
          .observation(v-for="(observation, index) in delivery.observations" :key="observation.createdAt")
            .observation-observation {{ index + 1 }}. {{ observation.observation }}
            div {{ dateTime(observation.createdAt) }}
            shNameUser(:dni="observation.createdBy")
</template>

<script>
import mForm from '@/mixins/form'
import mFilters from '@/mixins/filters'
import shExpandButton from '@/components/elements/ExpandButton'
import shNameUser from '@/components/elements/NameUser'
import shInputList from '@/components/elements/InputList'

export default {
  name: 'Delivery',

  components: { shExpandButton, shNameUser, shInputList },

  mixins: [mFilters, mForm],

  props: {
    delivery: Object,
    text: Object,
    conveyors: Array
  },

  mounted () {
    this.tracking.conveyor = this.delivery.conveyor
    this.tracking.tracking = this.delivery.tracking
  },

  data () {
    return {
      show: false,
      observations: [],
      observation: '',
      tracking: {
        conveyor: '',
        tracking: ''
      }
    }
  }
}
</script>

<style lang="stylus">
.delivery-order-container
  border-bottom 1px solid var(--color-border-items)
  border-radius 1em
</style>



// WEBPACK FOOTER //
// src/components/pages/change/Delivery.vue